// extracted by mini-css-extract-plugin
export default {"formWrapper":"styles_formWrapper__jgrHI","productListResultWrapper":"styles_productListResultWrapper__CCi7E"};